module.exports = {
      id: "logout-usage",
      viewBox: "0 0 75 28",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#logout",
      toString: function () {
        return this.url;
      }
    }